export const createTaskKanbanService = (fetch) => async (task) => {
  try {
    const response = await fetch({
      url: '/api/v1/plan-trabajo-capacitacion/crear-tarea',
      method: 'post',
      body: task
    })

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
}
